import React, { useState, } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import IPBSLineItemPaymentRecordView from './IPBSLineItemPaymentRecordView';

const IPBSLineItemPaymentRecordModal = ({ selectedLineItem, }) => {
  const [ show, setShow, ] = useState(false);

  return (
    <>
      <Button variant='primary' onClick={() => setShow(true)}>
        Details
      </Button>
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Line Item Payment Record Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <IPBSLineItemPaymentRecordView selectedLineItem={selectedLineItem} />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </>
  );
};

IPBSLineItemPaymentRecordModal.propTypes = {
  selectedLineItem: PropTypes.instanceOf(Object).isRequired,
};

export default IPBSLineItemPaymentRecordModal;
